import { render, staticRenderFns } from "./TransportOrderCtDetail.vue?vue&type=template&id=7f10b3f0&scoped=true"
import script from "./TransportOrderCtDetail.vue?vue&type=script&lang=js"
export * from "./TransportOrderCtDetail.vue?vue&type=script&lang=js"
import style0 from "./TransportOrderCtDetail.vue?vue&type=style&index=0&id=7f10b3f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f10b3f0",
  null
  
)

export default component.exports